import React from 'react';
import Slider from 'react-slick';

interface Testimonial {
  quote: string;
  name: string;
  position: string;
  image: string;
}

interface CustomArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const NextArrow: React.FC<CustomArrowProps> = ({ className, style, onClick }) => {
  return (
    <div
      className={`${className} custom-next-arrow`}
      style={{
        ...style,
        display: 'block',
        backgroundImage: "url('/assets/images/arrow_right.png')",
        backgroundSize: 'cover',
        width: '83px',
        height: '33px',
      }}
      onClick={onClick}
    />
  );
};

const PrevArrow: React.FC<CustomArrowProps> = ({ className, style, onClick }) => {
  return (
    <div
      className={`${className} custom-prev-arrow`}
      style={{
        ...style,
        display: 'block',
        backgroundImage: "url('/assets/images/arrow_left.png')",
        backgroundSize: 'cover',
        width: '83px',
        height: '33px',
      }}
      onClick={onClick}
    />
  );
};

const testimonials: Testimonial[] = [
  {
    quote:
      'Adivo was a lifesaver for us. It brought customers through our doors when we needed it most, and its innovative tracking tools gave us a clear picture of our customer base. We went from nearly closing to expanding — and we couldn’t be more grateful.',
    name: 'Isaac',
    position: 'Garage Owner',
    image: '/assets/images/placeholder.png',
  },
  {
    quote:
      'This app made it easy to get the word out locally and turn interest into paying customers. It’s simple to use, delivers great results, and has become an essential part of our growth.',
    name: 'Dr. Thomas Kohn',
    position: 'Owner of Cosmetic Treatment Clinic',
    image: '/assets/images/placeholder.png',
  },
  {
    quote:
      'Adivo has been a game-changer for us at The Deck People. The app streamlined our local marketing and helped us connect with the right customers faster. The leads we get are consistently high quality, turning into successful deals and driving real growth.',
    name: 'Dan Givon',
    position: 'CEO of The Deck People',
    image: '/assets/images/placeholder.png',
  },
];

const TestimonialCarousel: React.FC = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768, // For mobile screens
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, // Hide arrows on mobile
          centerMode: true, // Enable center mode
          centerPadding: '30px', // Show part of previous/next slides from edges
        },
      },
    ],
  };


  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <h2 className="text-center lg:text-[34px] text-[24px] lg:font-bold font-semibold font-inter mb-8 mt-16">Testimonials</h2>
      <Slider {...settings}>
        {testimonials.map((testimonial, index) => (
          <div key={index} className="px-4">
            <div className="bg-[#F7F5FF] rounded-xl p-6 lg:min-h-[368px] lg:min-w-[325px] flex flex-col">
              <img src="/assets/images/inverted-commas.png" className="w-10" />
              <p className="text-grayscale-800 font-inter text-base font-normal my-2">{testimonial.quote}</p>
              <div className="h-px bg-[#E5E7E7] w-full"></div>
              <div className="flex items-center lg:mt-auto mt-5">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full mr-4"
                />
                <div className="min-w-0">
                  <p className="font-bold text-black text-[22px] font-inter leading-tight truncate">
                    {testimonial.name}
                  </p>
                  <p className="text-sm font-inter font-normal text-grayscale-700 break-words">
                    {testimonial.position}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialCarousel;
